import { BaseEditor, Element, NodeEntry, Path, Editor } from 'slate'
import { cellType, isCellSpanning } from './mergeCells'
import { isEqual } from 'lodash'

export const getSpanningCell = (editor: BaseEditor, cellPath: Path) => {
  if (!cellPath || !Path.isPath(cellPath)) return

  const cellEntry = Editor.node(editor, cellPath)

  if (!cellEntry) return

  const [cell] = cellEntry

  if (!cell?.['attrs']?.['void']) return

  const tableEntry = Editor.above(editor, {
    match: (n) => {
      return n['type'] === 'table'
    },
    at: cellPath
  })

  if (!tableEntry) return

  const [table, tablePath] = tableEntry
  const colIndex = cellPath.at(-1)
  const relativeRowIndex = cellPath.at(-2)

  const [spanningCellEntry] = Editor.nodes(editor, {
    match: (node, path) => {
      if (!cellType.includes(node['type'])) return
      if (path.at(-1) > colIndex) return
      if (path.length !== cellPath.length) return
      if (!isEqual(path.slice(0, -2), cellPath.slice(0, -2))) return
      if (path.at(-2) > relativeRowIndex) return

      const { hasColSpan, hasRowSpan } = isCellSpanning(node)
      if (!hasColSpan && !hasRowSpan) return

      const { rowSpan, colSpan } = node['attrs']

      if (rowSpan && !colSpan && path.at(-1) !== colIndex) return false
      if (colSpan && !rowSpan && path.at(-2) !== relativeRowIndex) return

      if (rowSpan) {
        if (rowSpan + path.at(-2) < relativeRowIndex) return false
      }

      if (colSpan) {
        if (colSpan + path.at(-1) < colIndex) return false
      }

      return true
    },
    at: tablePath
  })

  return spanningCellEntry
}
